import React from 'react'
import styled from '@emotion/styled'
import { Input, Form, Select } from 'antd'
import { AddNewItem } from 'components'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'
import { useGlobalConfig } from 'context/config-context'
import { MinusButton } from 'views/ScanSettings/NewScan/style'
import {
	WEBHOOKS,
	WEBHOOK_NAME_FIELD,
	WEBHOOK_METHOD_TYPE_FIELD,
	WEBHOOK_URL_FIELD,
	WEBHOOK_BODY_FIELD,
	WEBHOOK_HEADERS,
	WEBHOOK_HEADER_NAME,
	WEBHOOK_HEADER_VALUE,
	WEBHOOK_KEYS,
	SUCCESS
} from 'views/ScanSettings/NewScan/constants'
import { remoteValidation, extractResponse, extractWebhook } from '../steps/validate';

const { Option } = Select
const { TextArea } = Input

const StyledFormRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '1fr 2fr',
	gridGap: 20
})

const HeadersTitle = styled.h3({
	marginBottom: 20
})

const StyledHeaderRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '1fr 2fr 40px',
	gridGap: 20
})

let webhookHeaderId = 0

const WebHooks = ({ form, webhooks, multiple = true, prefix, setValidationError }) => {
	const config = useGlobalConfig()
	const { getFieldDecorator, getFieldValue, setFieldsValue } = form

	getFieldDecorator(WEBHOOK_HEADERS, { initialValue: [] })
	let webHookHeaders = getFieldValue(WEBHOOK_HEADERS)

	const removeWebHookHeader = k => {
		webhookHeaderId--;
		setFieldsValue({
			[WEBHOOK_HEADERS]: webHookHeaders.filter(key => key !== k)
		})
	}

	const addWebHookHeader = () => {
		const webHookHeaders = getFieldValue(WEBHOOK_HEADERS)
		setFieldsValue({
			[WEBHOOK_HEADERS]: webHookHeaders.concat(webhookHeaderId++)
		})
	}

	const onRemoteValidation = async (values) => {		
		try{
			let failureResponse = { origin: 'server', errors: [] }
			if (values) 
			{
				let extracted = extractWebhook([values])
				let response = await remoteValidation(extracted, WEBHOOK_KEYS, '/global/webhooks/validate', failureResponse)
				response = extractResponse(response)
				failureResponse = response && !!response.length ? response : failureResponse
			}
			return !!failureResponse.errors.length ? failureResponse : SUCCESS;
		}
		catch(err){
			setValidationError(Array.isArray(err) ? err : [err.message]);
		}
	}

	const WebHookHeaderFields = webHookHeaders.map((k, index) => (
		<StyledHeaderRow key={k}>
			<Form.Item label="NAME">
				{getFieldDecorator(`${WEBHOOK_HEADER_NAME}[${k}]`, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Name is Required'
						}
					]
				})(<Input placeholder="Header Name" />)}
			</Form.Item>
			<Form.Item label="VALUE">
				{getFieldDecorator(`${WEBHOOK_HEADER_VALUE}[${k}]`, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'Value is Required'
						}
					]
				})(<Input placeholder="Header Value" />)}
			</Form.Item>
			{webHookHeaders.length > 0 ? (
				<MinusButton size="small" shape="circle" icon="minus" onClick={() => removeWebHookHeader(k)} />
			) : null}
		</StyledHeaderRow>
	))
	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={webhooks}
			dataType={prefix ? `${prefix}${WEBHOOKS}` : WEBHOOKS}
			dataTypeText="Webhooks"
			formFields={[
				WEBHOOK_NAME_FIELD,
				WEBHOOK_METHOD_TYPE_FIELD,
				WEBHOOK_URL_FIELD,
				WEBHOOK_BODY_FIELD,
				WEBHOOK_HEADER_NAME,
				WEBHOOK_HEADER_VALUE
			]}
			nameProp={WEBHOOK_NAME_FIELD}
			multiple={multiple}
			setValidationError={setValidationError}
		>
			<Form.Item label="NAME">
				{getFieldDecorator(WEBHOOK_NAME_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							required: true,
							whitespace: true,
							message: 'WebHook Name is Required.'
						}
					]
				})(<Input placeholder="Name" />)}
			</Form.Item>
			<StyledFormRow>
				<Form.Item label="TYPE">
					{getFieldDecorator(WEBHOOK_METHOD_TYPE_FIELD, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								message: 'WebHook Type is Required.'
							}
						]
					})(
						<Select placeholder="Method Type">
							{config['webhook_methods'].map(item => (
								<Option key={item} value={item}>
									{item}
								</Option>
							))}
						</Select>
					)}
				</Form.Item>
				<Form.Item label="URL">
					{getFieldDecorator(WEBHOOK_URL_FIELD, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								whitespace: true,
								message: 'WebHook URL is Required.'
							}
						]
					})(<Input placeholder="URL" />)}
				</Form.Item>
			</StyledFormRow>
			<Form.Item label="BODY">
				{getFieldDecorator(WEBHOOK_BODY_FIELD, {
					validateTrigger: ['onChange', 'onBlur'],
					rules: [
						{
							message: 'WebHook Body is Required.'
						}
					]
				})(<TextArea placeholder="Body" autosize={{ minRows: 10 }} />)}
			</Form.Item>
			<Form.Item>
				<HeadersTitle>HEADERS</HeadersTitle>
				{WebHookHeaderFields}
				<AddNewItem icon="plus" onClick={addWebHookHeader}>
					ADD NEW HEADER
				</AddNewItem>
			</Form.Item>
		</DynamicForm>
	)
}
export default WebHooks
